module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/videoposter.0c605446.png";